import { useNavigate } from 'react-router-dom';
import { useNavigateToScheduleCreate } from '../../ScheduleUtilities';
import { AssistanceService } from '../../services/AssistanceService';

type SchedulesFromEquipmentProps = {
}

function SchedulesFromEquipment(props: SchedulesFromEquipmentProps) {

    const assistanceService = new AssistanceService();
    const navigate = useNavigate();
    const navigateToScheduleCreate = useNavigateToScheduleCreate();


    return (
        <div>

        </div>

    )
}

export default SchedulesFromEquipment